import { AxiosResponse } from "axios"
import { apiUrl } from "../helpers/constants/config.constants"
import { httpDelete, httpGet, httpPost, httpPut } from "./http.service"

export type CampaignModel = {
  campaignId: string
  projectId: string
  name: string
  description: string
  campaignType: string
  bannerUrl: string
  bannerMobileUrl: string[]
  campaignWinnerUserId: string
  startDate: Date
  endDate: Date
  metadata: Record<string, unknown>
  status: string
  createdBy: string
  updatedBy: string
  createdAt: Date
  updatedAt: Date
  deletedAt: Date
}

export type PromoModel = {
  promoId: string
  title: string
  description: string
  productId: string
  bannerMobileUrls?: string[]
  bannerUrls?: string[]
  remark?: string
  status: string
  createdBy: string
  pdatedBy: string
  createdAt: Date
  updatedAt: Date
  deletedAt: Date
}

export function doListCampaigns(skip: number) {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.campaign.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doCreateCampaign(params: Record<string, unknown>) {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.campaign.create, { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doUpdateCampaign(params: Record<string, unknown>) {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.campaign.update(params.campaignId as string), { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doDeleteCampaign(id: string) {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.campaign.delete(id)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doListPromos(skip: number) {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.promo.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doCreatePromo(params: Record<string, unknown>) {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.promo.create, { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doUpdatePromo(params: Record<string, unknown>) {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.promo.update(params.promoId as string), { ...params }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doDeletePromo(id: string) {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.promo.delete(id)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}
